import {
  Box,
  Flex,
  Paper,
  Text,
  Title,
  Collapse,
  Divider,
} from "@mantine/core";
import "./Dashboard.scss";
import { useTranslation } from "react-i18next";
import useDashboardStore from "../../store/useDashboardStore";
import { useNavigate } from "react-router";
import useDevelopmentStore from "../../store/useDevelopmentStore";
import { useState } from "react";
import {
  ArrowDownIconGray,
  ArrowUpIconGray,
} from "../../shared/svg/ArrowUpIcon";
import { OnboardingTour } from "@gfazioli/mantine-onboarding-tour";
import { useMediaQuery } from "@mantine/hooks";

export const CurrentGoals = () => {
  const { t } = useTranslation();
  const { dashboard } = useDashboardStore();
  const {
    setCurrentLearningPlanId,
    fetchDevelopmentPlan,
    fetchLearningPlanGoals,
  } = useDevelopmentStore();
  const goals = dashboard?.user_goals || [];

  const mobile = useMediaQuery("(max-width:650px");

  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(false);

  const visibleGoalsCount = 3;
  const hasMore = goals.length > visibleGoalsCount;

  const handleGoalClick = async (learningPlanId: number, goalId: number) => {
    await fetchDevelopmentPlan();
    await fetchLearningPlanGoals(learningPlanId);
    setCurrentLearningPlanId(learningPlanId);
    navigate(`/development-plan?goalId=${encodeURIComponent(goalId)}`);
  };

  const Content = (
    <Flex direction="column" h="100%">
      {mobile ? (
        <OnboardingTour.Target id="dashboard-goals">
          <Title size={36} mb={40}>
            {t("current_goals")}
          </Title>
        </OnboardingTour.Target>
      ) : (
        <Title size={36} mb={40}>
          {t("current_goals")}
        </Title>
      )}

      {/* Контент цілей */}
      <Box style={{ flexGrow: 1, paddingRight: 8 }}>
        <Flex wrap="wrap" gap={16}>
          {goals.slice(0, visibleGoalsCount).map((goal, index) => (
            <Box
              key={index}
              style={{
                wordWrap: "break-word",
                maxWidth: "100%",
                cursor: "pointer",
              }}
              className="goal"
              onClick={() => handleGoalClick(goal.learning_plan_id, goal.id)}
            >
              {goal.title}
            </Box>
          ))}
        </Flex>

        <Collapse in={expanded}>
          <Flex mt={12} wrap="wrap" gap={16}>
            {goals.slice(visibleGoalsCount).map((goal, index) => (
              <Box
                key={`extra-${index}`}
                style={{
                  wordWrap: "break-word",
                  maxWidth: "100%",
                  cursor: "pointer",
                }}
                className="goal"
                onClick={() => handleGoalClick(goal.learning_plan_id, goal.id)}
              >
                {goal.title}
              </Box>
            ))}
          </Flex>
        </Collapse>

        {goals.length === 0 && <Text mt="sm">{t("no_goals_yet")}</Text>}
      </Box>

      {/* Footer — завжди внизу */}
      {hasMore && (
        <Box mt="auto" mb={-10}>
          <Divider my={22} color="gray.4" />
          <Flex w="100%" justify="center">
            <Box
              onClick={() => setExpanded((prev) => !prev)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  setExpanded((prev) => !prev);
                }
              }}
              className="expand-toggle-button"
              aria-label="toggle-goals"
            >
              {expanded ? <ArrowUpIconGray /> : <ArrowDownIconGray />}
            </Box>
          </Flex>
        </Box>
      )}
    </Flex>
  );

  return mobile ? (
    <Paper
      withBorder
      radius="24px"
      p={32}
      h="100%"
      style={{ display: "flex", flexDirection: "column" }}
    >
      {Content}
    </Paper>
  ) : (
    <OnboardingTour.Target id="dashboard-goals">
      <Paper
        withBorder
        radius="24px"
        p={32}
        h="100%"
        style={{ display: "flex", flexDirection: "column" }}
      >
        {Content}
      </Paper>
    </OnboardingTour.Target>
  );
};
